import { render, staticRenderFns } from "./SelectCDP.vue?vue&type=template&id=96985414&scoped=true&"
import script from "./SelectCDP.vue?vue&type=script&lang=js&"
export * from "./SelectCDP.vue?vue&type=script&lang=js&"
import style0 from "./SelectCDP.vue?vue&type=style&index=0&id=96985414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96985414",
  null
  
)

export default component.exports